import React, { useState } from "react";
import { downloadCmsImage } from "../utils/downloadCmsImage";

function CmsImageDownloadButton({ previewUrl, storedPath, className = "" }) {
  const [downloading, setDownloading] = useState(false);

  async function handleDownload(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!previewUrl || downloading) {
      return;
    }

    setDownloading(true);
    try {
      await downloadCmsImage(previewUrl, storedPath);
    } finally {
      setDownloading(false);
    }
  }

  return (
    <button
      type="button"
      className={`cms-image-download-btn ${className}`.trim()}
      onClick={handleDownload}
      disabled={downloading}
      title="Download image"
      aria-label="Download image"
    >
      <i
        className={`mdi ${downloading ? "mdi-loading mdi-spin" : "mdi-download"}`}
        aria-hidden="true"
      />
    </button>
  );
}

export default CmsImageDownloadButton;
